/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import './AccountDisplay.scss';

import { shape, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import AccountLabel from 'components/shared/AccountLabel/AccountLabel';

const MobileAccountDisplay = ({ account }) => (
  <div className="account-display">
    <div>
      <Link
        className="account-name"
        to={`/account-details?id=${account.accountId}`}>
        {account.accountName}
      </Link>
      {account.ticker && (
        <span className="account-ticker">{account.ticker}</span>
      )}
    </div>
    <div>
      <span className="account-number">{account.accountWChecksum}</span>
    </div>
    <div>
      <span className="account-type">{account.accountType}</span>
      <span className="spacing-dot" />
      <span className="owners">{account.owners}</span>
      <AccountLabel accountId={account.accountId}/>
    </div>
  </div>
);

MobileAccountDisplay.propTypes = {
  account: shape({
    accountName: string.isRequired,
    accountType: string,
    accountId: string.isRequired,
    accountWChecksum: string.isRequired,
    owners: string.isRequired
  })
};

export default MobileAccountDisplay;
